module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QwECjIggNfpvgAAAN1JREFUWMNjYBgFQw3871zx/3/niv/UMo+FFItp4SEmSkKCGg5gpNQixvIIxgEJAWqFBE4HTNkfokSs4ejq/v//L4NVHEsCxumA7FMhd8kNCUZGxifEOp6JWsGKnBaQ9f/vXPH/4dtzAUQ7gKw4LQvXxqdfbs6t9UQ5gNwExcjIeI2UKHr24bochgPIthxH0JOUCwbKcqqUA1SpC9BLM2y+ganBJkeq76UENB8NrhCgZpGLLaTwhd6AhwATKSme0pqPoiigJKrwRd/wS4SDpiAiNs0MnVwwbB0wCkYBAFjNhkSxmUrwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/no_activas_bi_sin.png
// module id = mvSA
// module chunks = 0